import React, { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { useDispatch } from "react-redux";
import { IApplication, IMajSpider, setActualites, setAgent, setAllSpiderApp, setApplication, setBanniere, setBlogs, setCategorie, setContact, setEtablissement, setFilteredActualites, setFilteredAgent, setFilteredApplication, setFilteredBanniere, setFilteredBlogs, setFilteredContact, setFilteredEtablissement, setFilteredFlashInfo, setFilteredFonction, setFilteredMajSpider, setFilteredService, setFlashInfo, setFonction, setMajSpider, setService, setTypeMaj } from "../store/siteWebSlice";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import Actualite from "./Actualite/Actualite";
import Agent from "./Agent/Agent";
import Application from "./Application/Application";
import Banniere from "./Banniere/Banniere";
import Contact from "./Contact/Contact";
import Etablissement from "./Etablissement/Etablissement";
import FlashInfo from "./FlashInfo/FlashInfo";
import Fonction from "./Fonction/Fonction";
import MajSpider from "./MajSpider/MajSpider";
import Onglet from "./Onglet";
import Service from "./Service/Service";
import Blog from "./Blog/Blog";


export const dataOnglet = [
  { id: 0, libelle: "Actualité" },
  { id: 1, libelle: "Blog" },
  { id: 2, libelle: "Flash info" },
  { id: 3, libelle: "Application" },
  { id: 4, libelle: "Agent" },
  { id: 5, libelle: "Contact" },
  { id: 6, libelle: "Bannière" },
  { id: 7, libelle: "Service" },
  { id: 8, libelle: "Fonction" },
  { id: 9, libelle: "Mise à jour spider" },
  { id: 10, libelle: "Etablissement" },
]


const SipderWebSite = () => {


  const dispatch = useDispatch();

  //hooks
  const [active, setActive] = useState(0)


  const renderContent = () => {
    if (active === 0) {
      return (<Actualite />)
    } else if (active === 1) {
      return (<Blog />)
    }
    else if (active === 2) {
      return (<FlashInfo />)
    }
    else if (active === 3) {
      return (<Application />)
    }
    else if (active === 4) {
      return (<Agent />)
    }
    else if (active === 5) {
      return (<Contact />)
    }
    else if (active === 6) {
      return (<Banniere />)
    }
    else if (active === 7) {
      return (<Service />)
    }
    else if (active === 8) {
      return (<Fonction />)
    }
    else if (active === 9) {
      return (<MajSpider />)
    }
    else if (active === 10) {
      return (<Etablissement />)
    }

  }


  const getActualite = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupactualite"
      );
      if (res.status === 1) {
        dispatch(setActualites(res.data));
        dispatch(setFilteredActualites(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:87 ~ getActualite ~ error:", error)
    }
  };

  const getFlashInfo = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupflashinfo"
      );
      if (res.status === 1) {
        dispatch(setFlashInfo(res.data));
        dispatch(setFilteredFlashInfo(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:87 ~ getActualite ~ error:", error)
    }
  };

  const getBannieres = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupbanniere"
      );
      if (res.status === 1) {
        dispatch(setBanniere(res.data));
        dispatch(setFilteredBanniere(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:87 ~ getActualite ~ error:", error)
    }
  };

  const getFonctions = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupfonction"
      );
      if (res.status === 1) {
        dispatch(setFonction(res.data));
        dispatch(setFilteredFonction(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:87 ~ getActualite ~ error:", error)
    }
  };

  const getContacts = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupcontact"
      );
      if (res.status === 1) {
        dispatch(setContact(res.data));
        dispatch(setFilteredContact(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };

  const getServices = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupservice"
      );
      if (res.status === 1) {
        dispatch(setService(res.data));
        dispatch(setFilteredService(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };

  const getAgents = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupagent"
      );
      if (res.status === 1) {
        dispatch(setAgent(res.data));
        dispatch(setFilteredAgent(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };

  const getApplications = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupapplication"
      );
      if (res.status === 1) {
        const formatedData = res.data.map((app: IApplication) => {
          return {
            ...app,
            checkListe: JSON.parse(app.checkListe)
          };
        });
        dispatch(setApplication(formatedData));
        dispatch(setFilteredApplication(formatedData));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };

  const getMajSpiders = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupspiderallversions"
      );
      if (res.status === 1) {
        // console.log("🚀 ~ file: index.tsx:243 ~ formatedData ~ res.data:", res.data)
        const formatedData = res.data.map((version: IMajSpider) => {
          return {
            ...version,
            VersionDescriptionArray: JSON.parse(version.VersionDescriptionArray)
          };
        });
        // console.log("🚀 ~ file: index.tsx:241 ~ formatedData ~ formatedData:", formatedData)
        dispatch(setMajSpider(formatedData));
        dispatch(setFilteredMajSpider(formatedData));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };

  const getEtabs = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupetablissement"
      );
      if (res.status === 1) {
        dispatch(setEtablissement(res.data));
        dispatch(setFilteredEtablissement(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };


  const getStudents = async () => {
    try {
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, "/tablesystem/getStudents");
      if (res.status === 1) {

      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:158 ~ getContacts ~ error:", error)
    }
  };


  const getCategorie = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupcategorie"
      );
      if (res.status === 1) {
        dispatch(setCategorie(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:287 ~ getCategorie ~ error:", error)
    }
  };

  const getArticle = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/recupblog"
      );
      if (res.status === 1) {
        dispatch(setBlogs(res.data));
        dispatch(setFilteredBlogs(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:287 ~ getCategorie ~ error:", error)
    }
  };

  const getTypeMaj = async () => {
    try {
      // dispatch(setTypeMaj([
      //   { idTypeMaj: 1, libTypeMaj: "Fichier d'installation x-server" },
      //   { idTypeMaj: 2, libTypeMaj: "Fichier d'installation spider" }
      // ]));
      // return
      const res: any = await apiClient.get(SITEWEB_SERVER_BASE_URL, "/recuptypemaj");
      if (res.status === 1) {
        dispatch(setTypeMaj(res.data));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: index.tsx:324 ~ getTypeMaj ~ error:", error)
    }
  };

  // Obtenir toutes les applications de Spider Technologies
  const recupApplication = async () => {
    try {
      const res: any = await apiClient.get(
        SITEWEB_SERVER_BASE_URL,
        "/getallproduit"
      );
      if (res.status === 1) {
        dispatch(setAllSpiderApp(res.data))
      }
        console.log("🚀 ~ recupApplication ~ res.data*///////:", res.data)
    } catch (error) {
      console.log("🚀 ~ recupApplication ~ error:", error)
    }
  };

  useEffect(() => {
    getActualite();
    getFlashInfo();
    getBannieres();
    getFonctions();
    getContacts();
    getServices();
    getAgents();
    getApplications();
    getMajSpiders();
    getEtabs();
    getStudents();
    getCategorie();
    getArticle();
    getTypeMaj();
    recupApplication();
  }, []);


  return (
    <div
      style={{
        padding: 10,
        height: "80vh",
        overflow: "auto",
      }}
    >
      {/* <Grid item md={12} xs={12} sm={12}> */}
      <Onglet
        active={active}
        setActive={setActive}
      />
      {/* </Grid> */}
      {renderContent()}
    </div>
  );
};
export default SipderWebSite;
